import Swiper from 'swiper/bundle';
export default class Slider {
    constructor() {
        const swiper = new Swiper('.hero-swiper', {
            autoplay: {
                delay: 5000,
                disableOnInteraction: true,
            },
            speed: 2000,
            autoHeight: true,
            slidesPerView: 1,
            loop: false,
            effect: "fade",
            pagination: {
                el: '.swiper-pagination',
                dynamicBullets: true,
                clickable: true,
            }
        });
    }
}